'use strict';

/**
 *
 * @name: playButton
 *
 */

function PlayButtonDirective($rootScope) {

  'ngInject';

  return {
    restrict: 'C',
    replace: false,
    transclude: false,
    scope: {
      post: '=',
      analyticsLabel: '@'
    },
    link: function(scope, element) {

      $(element).on('click', function() {

        $rootScope.analytics.buttons('play', scope.analyticsLabel, scope.post);
      });
    }
  };
}

export default PlayButtonDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-play-button.directive.js